var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-fileds-wrap" },
    [
      _c(
        "button",
        {
          directives: [
            {
              name: "b-toggle",
              rawName: "v-b-toggle.sidebar-table-fields",
              modifiers: { "sidebar-table-fields": true },
            },
          ],
          staticClass: "btn btn-primary btn-micro",
        },
        [_vm._m(0)]
      ),
      _c(
        "b-sidebar",
        {
          attrs: {
            id: "sidebar-table-fields",
            title: "Table Fileds Settings",
            backdrop: "",
            right: "",
            shadow: "",
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Visible fields" } },
            _vm._l(_vm.filedsOptions, function (option) {
              return _c(
                "b-form-checkbox",
                {
                  key: option.key,
                  attrs: { value: option.key, name: "flavour-3a" },
                  on: {
                    change: function ($event) {
                      return _vm.$emit(
                        "onRefetchTableColumns",
                        option,
                        _vm.selected
                      )
                    },
                  },
                  model: {
                    value: _vm.selected,
                    callback: function ($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected",
                  },
                },
                [_vm._v("\n        " + _vm._s(option.label) + "\n      ")]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "btn-with-icon-content" }, [
      _c("i", {
        staticClass: "el-icon-setting",
        staticStyle: { "margin-right": "10px" },
      }),
      _vm._v("\n      Settings\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }